<div class="purchase-review flex flex--column grow--min ie--use-100vh grey-25-bg">
  <fin-booking-plain-header-area [title]="'purchase.review.title' | finLocalization"></fin-booking-plain-header-area>

  <ng-container *ngIf="isChangingStep || (cartOrOrder$ | async) === undefined; else reviewContent">
    <fin-loader [waitingFor]="'purchase.review.updatingCart'"></fin-loader>
  </ng-container>

  <ng-template #reviewContent>
    <fin-booking-notification [isFullWidth]="false" [theme]="NotificationTheme.SUCCESS"></fin-booking-notification>
    <fcom-notification *ngIf="isOrder$ | async" class="block pr-small-b"
      >{{ 'purchase.createdByCustomerCare' | finLocalization }}
    </fcom-notification>

    <fcom-trip-card
      *ngIf="cartOrOrder$ | async as booking"
      [departureDate]="booking.bounds[0].departure.dateTime | finDateFormat: 'DATE'"
      [arrivalDate]="booking.bounds[booking.bounds.length - 1].arrival.dateTime | finDateFormat: 'DATE'"
      [flightTotalPriceAmount]="totalPrice$ | async | finPrice: { useSymbol: true }"
      [totalPoints]="totalPoints$ | async | finPoints"
      [title]="booking.bounds.length > 2 ? ('multiCity.flightSelection.title' | finLocalization) : null"
      [destinations]="summary$ | async"
      [passengerAmount]="booking.passengers.length"
      [image]="image$ | async"
      [showExpandButton]="false"
      [showStartOverButton]="(isOrder$ | async) === false"
      (ctaClick)="backToDateSelection()"
    >
    </fcom-trip-card>

    <fin-saf-contribution-product
      *ngIf="enableSafContributionCard$ | async"
      [cartOrOrder$]="cartOrOrder$"
      [servicesReady$]="servicesReady$"
    ></fin-saf-contribution-product>

    <div *ngIf="cartOrOrder$ | async as booking" class="mr-xsmall-y">
      <h2 class="ms-medium-b font-heading-4">{{ 'purchaseSummaryItemNames.flights' | finLocalization }}</h2>

      @if (multiCityStopoverDurationNotification$ | async) {
        <fcom-notification
          class="ms-medium-b"
          [theme]="NotificationTheme.WARNING"
          [iconCategory]="IconLibrary.SVG_LIBRARY"
          [iconName]="SvgLibraryIcon.CLOCK"
          [title]="'multiCityNotification.stopOverNotification.title' | finLocalization"
        >
          {{ 'multiCityNotification.stopOverNotification.text' | finLocalization }}
        </fcom-notification>
      }

      @if (hasTrainSegment$ | async) {
        <fcom-notification
          class="ms-medium-b"
          data-testid="journey-includes-train-notification"
          [theme]="NotificationTheme.INFO"
          [iconCategory]="IconLibrary.SVG_LIBRARY"
          [iconName]="SvgLibraryIcon.TRAIN"
          [linkUrl]="'purchase.review.containsTrainNotification.link.url' | finLocalization"
          [linkText]="'purchase.review.containsTrainNotification.linkText' | finLocalization"
          [linkOpenInNewWindow]="true"
        >
          <span>
            {{ 'purchase.review.containsTrainNotification.description' | finLocalization }}
          </span>
        </fcom-notification>
      }

      <div *ngFor="let bound of booking.bounds; index as i; first as isFirst" [ngClass]="{ 'pr-xsmall-t': !isFirst }">
        <fin-flight-card
          [flightOrBound]="bound"
          [passengers]="booking.passengers"
          [locations]="booking.locations"
          [title]="
            'bookingSummary.boundTitle'
              | finLocalization
                : {
                    index: i + 1,
                    departureCity: bound.departure.locationCode,
                    arrivalCity: bound.arrival.locationCode,
                  }
          "
          [hideModify]="(isOrder$ | async) === true"
          [roundedBottom]="(isOrder$ | async) === true"
          (viewDetails)="handleViewDetailsModal(i)"
          (modifyClicked)="edit.emit({ next: STEPS.FLIGHT_SELECTION, openGlobalBookingWidget: true })"
        >
        </fin-flight-card>
        <div
          *ngIf="(isOrder$ | async) === false"
          class="border-bottom border-left border-right rounded-bottom-large white-bg ps-medium"
        >
          <div data-testid="ticket-details" class="flex flex--column">
            <button
              class="flex-1 flex flex--space-between"
              (click)="handleFlightCardToggle(i)"
              [attr.aria-label]="
                (flightCardExpandersOpen[i]
                  ? 'purchase.review.flightCard.ariaHide'
                  : 'purchase.review.flightCard.ariaShow'
                ) | finLocalization
              "
              [attr.aria-controls]="'bound-control-' + bound.id"
              [attr.aria-expanded]="flightCardExpandersOpen[i]"
              [id]="'bound-button-' + bound.id"
            >
              <h3 class="font-heading-4 ticket-details-heading">
                {{ 'purchase.review.ticketDetails' | finLocalization }}
                <span class="font-body-1 regular-type">{{ '(' + bound.fareFamilyBrandName + ')' }}</span>
              </h3>
              <fcom-icon
                class="rotate nordic-blue-900-text"
                [class.rotate-active]="flightCardExpandersOpen[i]"
                [dataTestId]="'ticket-details-arrow-icon'"
                [name]="SvgLibraryIcon.CHEVRON_DOWN"
              ></fcom-icon>
            </button>
            <div
              data-testid="ticket-details-collapsed"
              *ngIf="!flightCardExpandersOpen[i]"
              class="flex flex--column ms-medium-t font-body-1"
            >
              <span data-testid="rebook-policy" *ngIf="(rebookPolicies$ | async).length > 0" class="bold-type"
                >{{ (rebookPolicies$ | async)[i]?.label }}
                <span class="regular-type">{{ (rebookPolicies$ | async)[i]?.value }}</span></span
              >
              @if ((cancellationPolicies$ | async).length > 0) {
                <span data-testid="cancellation-policy" class="bold-type"
                  >{{ (cancellationPolicies$ | async)?.[i]?.label }}
                  <span class="regular-type">{{ (cancellationPolicies$ | async)?.[i]?.value }}</span></span
                >
                @if ((inboundShowFlexTicketNotification$ | async) === bound.id) {
                  <fcom-notification
                    class="ms-xsmall-t"
                    [theme]="NotificationTheme.INFO"
                    [compact]="true"
                    data-testid="longHaulFlexTicketRefund-notification"
                  >
                    <p [innerHTML]="'purchase.review.longHaulFlexTicketRefund' | finLocalization"></p>
                  </fcom-notification>
                }
              }
            </div>
          </div>

          <fcom-expand
            [open]="flightCardExpandersOpen[i]"
            [ariaId]="'bound-control-' + bound.id"
            [ariaLabelledBy]="'bound-button-' + bound.id"
          >
            <div data-testid="ticket-details-expanded" class="flex flex--column ms-medium-t">
              <fin-fare-family-table [fareFamilies]="[booking.benefits[bound.fareFamilyCode]]"></fin-fare-family-table>
              @if ((inboundShowFlexTicketNotification$ | async) === bound.id) {
                <div>
                  <fcom-notification
                    class="ms-small-t"
                    [theme]="NotificationTheme.INFO"
                    [compact]="true"
                    data-testid="longHaulFlexTicketRefund-notification-expand"
                  >
                    <p [innerHTML]="'purchase.review.longHaulFlexTicketRefund' | finLocalization"></p>
                  </fcom-notification>
                </div>
              }
              <button
                data-testid="full-fare-rules-modal-button"
                *ngIf="(isOrder$ | async) === false"
                class="font-body-2 type-medium ms-medium-t underline align-left"
                (click)="openTicketRulesModal(bound)"
              >
                {{ 'purchase.review.fullFareRules.title' | finLocalization }}
              </button>
            </div>
          </fcom-expand>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showSustainableMessages$ | async" data-testid="saf-notification-renewed">
      <h2 data-testid="purchase-review-prices-title" class="font-heading-3 mr-xsmall-t">
        {{ 'safNotification.sectionHeader' | finLocalization }}
      </h2>

      <fin-section-review class="mr-xsmall-t" [noButton]="true">
        <ng-container ngProjectAs="content">
          <ng-container *ngIf="safContributionUrl$ | async">
            <fin-sustainability-trip-message
              data-testid="saf-contribution"
              *ngIf="shouldDisplaySafContributionMessage$ | async"
              [fragmentKey]="'fragments.safContribution.url'"
              [linkText]="'safNotification.sustainabilityLinkText' | finLocalization"
            ></fin-sustainability-trip-message>
          </ng-container>

          <fin-sustainability-trip-message
            data-testid="combined-trip"
            *ngIf="shouldDisplayCombinedTripMessage$ | async"
            class="mr-medium-t"
            [fragmentKey]="'fragments.combinedTrip.url'"
          ></fin-sustainability-trip-message>
        </ng-container>
      </fin-section-review>
    </ng-container>
    <ng-container>
      <h2 data-testid="purchase-review-passengers-title" class="font-heading-4 mr-xsmall-t">
        {{ 'passengerReview.title' | finLocalization }}
      </h2>
      <fin-section-review
        class="mr-xsmall-t purchase-review-passengers-list"
        [fullWidth]="true"
        [noButton]="isOrder$ | async"
      >
        <ng-container ngProjectAs="content">
          <fin-passenger-info-list
            class="mr-small-x"
            [passengers$]="cartOrOrder$ | finMap: 'passengers'"
            [cartData$]="cartOrOrder$"
            [showEdit]="enableEditPaxDetailsOnReviewPage"
            [isOrder]="isOrder$ | async"
            [profileType$]="profileType$"
            [isSaving$]="cartOrOrderStatusUpdating$"
            [allFrequentFlyerCards$]="allFrequentFlyerCards$"
            [controlData$]="controlData$"
          ></fin-passenger-info-list>
        </ng-container>
      </fin-section-review>
    </ng-container>

    @if (enableAdditionalEmailInBookingFlow && (isOrder$ | async) === false) {
      <fin-section-review
        class="mr-xsmall-t"
        [noButton]="true"
        [fullWidth]="true"
        [attr.data-testid]="'additional-email-section'"
      >
        <ng-container ngProjectAs="content">
          <h2 class="ms-large-l font-heading-4 nordic-blue-900-text">
            <span>{{ 'additionalEmail.sectionTitle' | finLocalization }}</span>
          </h2>
          <fin-additional-email
            class="flex--basis-full ps-large-b ps-large-x"
            [controlName]="'additionalEmail'"
            [placeholder]="'additionalEmail.placeholder'"
            [disabledPlaceholder]="'additionalEmail.disabledPlaceholder'"
            [buttonText]="'additionalEmail.button'"
            [isLoading]="cartOrOrderStatusUpdating$ | async"
            [parentForm]="paxForm"
            [emailsArray]="emailsArray"
            (addEmail)="addEmail()"
            (removeEmail)="removeEmail($event)"
          ></fin-additional-email>
        </ng-container>
      </fin-section-review>
    }

    <fin-included-products
      class="block mr-xsmall-t"
      [headingClasses]="'font-heading-3'"
      *ngIf="(services$ | async)?.length"
      [servicesToShow]="services$ | async"
      [booking]="cartOrOrder$ | async"
      [useCabinClass]="false"
      [showModifyButtons]="(isOrder$ | async) === false"
      (upsellClicked)="edit.emit({ next: STEPS.ANCILLARIES })"
      [titleTranslationKey]="'MMB.labels.includedInTrip'"
    ></fin-included-products>

    <ng-container *ngIf="(isOrder$ | async) === false && (catalogCategory$ | async) !== null">
      <h2 class="font-heading-3 mr-xsmall-t purchase-review-cancellation-cover">
        {{ 'localSettings.ancillaries.cover.sectionTitle' | finLocalization }}
      </h2>
      <fin-pax-ancillary-product
        [translations]="scsWithSelection.translations"
        [loadingTitle]="'localSettings.ancillaries.cover.loadingTitle' | finLocalization"
        [categoryWithSelections$]="coverServicesWithSelection$"
        [category]="scsWithSelection?.category"
        [servicesReady$]="servicesReady$"
        [media]="(catalogCategory$ | async)?.media"
        [price$]="scsWithSelection?.totalPrice | finToObservable"
        [analyticsContext]="'booking-flow_review-page'"
        (selectionChanged)="updateSelectionsForFragment($event)"
        [attr.data-testid]="'pax-ancillary-' + scsWithSelection?.category"
        [showInfoButton]="false"
        [isLoading$]="coverIsLoading$"
      />
    </ng-container>

    <h2 data-testid="purchase-review-prices-title" class="font-heading-3 mr-xsmall-t">
      {{ 'purchase.review.priceBreakdown' | finLocalization }}
    </h2>

    <fin-section-review
      class="mr-xsmall-t purchase-review-renewed-prices"
      [fullWidth]="true"
      [noButton]="true"
      [roundedBottom]="false"
    >
      <ng-container ngProjectAs="content">
        <fin-price-breakdown-renewed
          class="flex--basis-full"
          [prices$]="cartOrOrder$ | finMap: 'prices.unpaid'"
          [passengers$]="cartOrOrder$ | finMap: 'passengers'"
          [showPoints]="(serviceFlow$ | async) === ServiceFlow.AWARD"
        >
        </fin-price-breakdown-renewed>
      </ng-container>
    </fin-section-review>

    <fin-grand-total
      [theme]="GrandTotalTheme.RENEWED"
      [useSymbol]="true"
      class="purchase-review-total-prices block mr-large-b"
      data-testid="purchase-review-grand-total"
      [prices$]="cartOrOrder$ | finMap: 'prices.unpaid'"
      [serviceFlow$]="serviceFlow$"
    ></fin-grand-total>

    <fin-section-review
      *ngIf="'fragments.contactDetailsForPayment.url' | finLocalization"
      class="mr-xsmall-y"
      [noButton]="true"
    >
      <ng-container ngProjectAs="content">
        <cms-unstyled-fragment
          class="block font-body-1 white-bg unstyled-fragment-line-height rounded"
          [contentUrl$]="'fragments.contactDetailsForPayment.url' | finLocalization | finToObservable"
        >
        </cms-unstyled-fragment>
      </ng-container>
    </fin-section-review>

    <fin-multi-city-survey class="block mr-small-b"></fin-multi-city-survey>

    <fcom-cta-button
      data-testid="purchase-review-proceed-payment-cta-button"
      [visible]="true | finToObservable | finDelay | async"
      [title]="'purchase.review.proceed' | finLocalization"
      [disabled]="cartOrOrderStatusUpdating$ | async"
      [position]="ButtonPosition.GRID_FULL"
      (buttonClicked)="ready.emit(true)"
    >
      <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
      <span *ngIf="totalPoints$ | async as points" class="font-body-1" data-testid="review-page-cta-points"
        >{{ 'award.points' | finLocalization: { pointsAmount: points || 0 | finPoints } }}&nbsp;+
      </span>
      <span class="font-body-1 bold-type" data-testid="review-page-cta-price">{{
        totalPrice$ | async | finPrice: { useSymbol: false }
      }}</span>
      <fcom-icon
        *ngIf="cartOrOrderStatusUpdating$ | async"
        [attr.aria-label]="'ctaButton.loading' | finLocalization"
        class="ms-xsmall-l icon-medium loading-icon"
        [name]="SvgLibraryIcon.TRANSFER_LOADER"
      ></fcom-icon>
    </fcom-cta-button>
  </ng-template>
  <fcom-modal
    data-testid="itinerary-timeline-modal"
    [open]="isTimelineModalOpen"
    (openChange)="isTimelineModalOpen = $event"
    [title]="'MMB.view.itineraryModal.title' | finLocalization"
    [buttons]="ModalButtons.DONE"
  >
    <fin-itinerary-timeline
      [bound]="(cartOrOrder$ | async)?.bounds[timelineBoundIndex]"
      [locations]="(cartOrOrder$ | async)?.locations"
      [boundType]="timelineBoundIndex === 0 ? BoundType.outbound : BoundType.inbound"
      [isBookingFlow]="true"
      class="block pr-medium"
    >
    </fin-itinerary-timeline>
  </fcom-modal>
  <fcom-modal
    data-testid="full-ticket-rules-modal"
    [open]="isTicketRulesModalOpen"
    [title]="'Full ticket rules'"
    [buttons]="ModalButtons.DONE"
    (openChange)="isTicketRulesModalOpen = $event"
  >
    <fcom-notification subtitle>
      <fin-flight-summary
        *ngIf="activeBoundInModal$ | async"
        [flightOrBound]="activeBoundInModal$ | async"
      ></fin-flight-summary>
    </fcom-notification>

    <fin-purchase-review-fare-rules
      *ngIf="isTicketRulesModalOpen"
      [passengers]="(cartOrOrder$ | async).passengers"
      [cartId]="(cartOrOrder$ | async).id"
      [bound]="activeBoundInModal$ | async"
    ></fin-purchase-review-fare-rules>
  </fcom-modal>
</div>
